export default "__VITE_ASSET__CkO_498g__"